pageId = 'page-subgroups-index'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $list = $('.member-groups-list')

  $list.sortable
    handle: '.group-link'
    scrollSensitivity: 20
    cursor: 'move'
    distance: 5
    helper: 'clone'
    items: '.group'
    placeholder: 'group-placeholder'
    tolerance: 'pointer'
    update: (e, ui) ->
      data = $list.find('.group').map ->
        return $(@).data('guid')
      .get().join(',')

      $.ajax
        url: "/teams/#{tower.team.guid}/subgroup_reorder"
        type: 'put'
        data:
          guids: data
        success: ->
          tower.highlight ui.item
